import request from '@/utils/http'

/**
 * 视频库分类
 * @param payload
 */
export function group_list(payload) {
    return request({ url: '/Storage/groupList', method: 'post', data: payload })
}

/**
 * 视频列表
 * @param payload
 */
export function video(payload) {
    return request({ url: '/Storage/videoList', method: 'post', data: payload })
}

/**
 * 上传视频
 * @param payload
 */
export let upload = process.env.VUE_APP_API_BASE_URL + '/Storage/uploadVideo';